import React from "react";
import { Checkbox, FlatButton } from "material-ui";

import BaseOverlay from "./partials/overlays/base.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import InfoNotice from "./partials/info-notice.jsx";
import LinkLike from "./partials/link-like.jsx";
import Label from "./partials/label.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketActions from "../actions/EventBucketActions";
import EventBucketStore from "../stores/EventBucketStore";

class EventBucketDuplicate extends React.Component {
  constructor(props) {
    super(props);

    const options = [
      { label: "Event bucket settings and design", disabled: true },
      { label: "Pass buckets", field: "pass_buckets" },
      {
        label: "Events/virtual screenings and ticket buckets",
        field: "events"
      },
      { label: "Films", field: "films" },
      { label: "Tags", field: "tags" },
      { label: "Venues", field: "venues" },
      { label: "Item buckets", field: "item_buckets" },
      { label: "Discounts", field: "coupons" },
      { label: "Mailings", field: "mailings" }
    ];

    let selected = {
      pass_buckets: true,
      tags: true,
      venues: true
    };

    this.state = {
      options,
      selected
    };

    this.close = this.close.bind(this);
    this.duplicate = this.duplicate.bind(this);
  }

  static getStores() {
    return [EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      isWorking: EventBucketStore.getState().isWorking,
      newEventBucketId: EventBucketStore.getState().newEventBucketId,
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  close() {
    this.context.router.push(
      `/event_buckets/${this.props.params.eventBucketId}/settings`
    );
  }

  duplicate() {
    EventBucketActions.duplicate(this.props.params.eventBucketId, {
      fields: Object.keys(this.state.selected).filter(
        k => !!this.state.selected[k]
      )
    });
  }

  componentWillReceiveProps(props) {
    if (props.newEventBucketId) {
      window.scrollTo(0, 0);
      this.context.router.replace(
        `/event_buckets/${props.newEventBucketId}/settings`
      );
    }
  }

  render() {
    let styles = this.getStyles(),
      bucket = this.props.getEventBucketById(this.props.params.eventBucketId);

    return (
      <BaseOverlay
        title={`Duplicate ${bucket ? `"${bucket.name}"` : ""}`}
        hideTitleAndFooterBorders={true}
        useMuiDefaultStyle={true}
        openImmediately={true}
        actions={[
          <FlatButton label={"Cancel"} onTouchTap={this.close} />,
          <FlatButton
            label={"Duplicate event bucket"}
            onTouchTap={this.duplicate}
            primary={true}
          />
        ]}
        modal={true}
        open={true}
        onRequestClose={this.close}
      >
        {!bucket || this.props.isWorking ? (
          <WorkingIndicator fullPage={true} />
        ) : (
          <div>
            <InfoNotice style={{ fontSize: 12 }}>
              Check out our{" "}
              <a
                href="https://help.eventive.org/events-and-tickets/duplicate-an-event-bucket"
                target="_blank"
              >
                guide to duplicating event buckets
              </a>
              .
            </InfoNotice>
            <p>Choose what to copy, then click "Duplicate event bucket".</p>
            {this.state.options.map(({ label, field, disabled }) => {
              return (
                <Checkbox
                  checked={disabled || this.state.selected[field]}
                  disabled={disabled}
                  label={label}
                  style={{ marginBottom: 5, width: 400 }}
                  onCheck={() => {
                    let { selected } = this.state;
                    selected[field] = !selected[field];
                    this.setState({ selected });
                  }}
                />
              );
            })}
          </div>
        )}
      </BaseOverlay>
    );
  }
}

export default connectToStores(EventBucketDuplicate);



// WEBPACK FOOTER //
// ./src/app/components/event-bucket-duplicate.jsx